

import { createBrowserRouter } from "react-router-dom";


import DashboardLayout from "./layout/Dashboard";
import Dashboard from "./pages/Dashboard";
import Root from "./layout/Root";
import Login from "./pages/auth/Login";
import OrderDetail from "./pages/OrderDetail";
import ManageStaff from "./pages/ManageStaff";
import StaffDetails from "./pages/ManageStaff/StaffDetails";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/Customers/CustomerDetail";
import Product from "./pages/OrderDetail/Product";
import Catalog from "./pages/Catalog";
import CatalogProduct from "./pages/Catalog/CatalogProduct";
import AllChat from "./pages/AllChat";
import ProductGroup from "./pages/ProductGroup";
import SubmittedProduct from "./pages/OrderDetail/SubmiitedOrder";
import ErrorPage from "./pages/ErrorPage";
import CenteredLayout from "./layout/CenteredLayout";
import AllDiscussion from "./pages/AllDiscussion";
import HelpCenter from "./pages/HelpCenter";
import OrderTags from "./pages/OrderTags";
import TrackOrder from "./pages/TrackOrder";

export const router = createBrowserRouter([

    {
        path: '/',
        element: <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <DashboardLayout />,
                children: [
                    {
                        path: '',
                        element: <Dashboard />
                    },
                    {
                        // Standard centered content width; excludes the Kanban dashboard above.
                        element: <CenteredLayout />,
                        children: [
                    {
                        path: '/order/:id/:orderRef/:customer_id',
                        element: <OrderDetail />,
                    },
                    {
                        path: '/manage-staff',
                        element: <ManageStaff />,
                    },
                    {
                        path: '/manage-staff/:staffId',
                        element: <StaffDetails />,
                    },
                    {
                        path: '/allchat',
                        element: <AllChat />,
                    },
                    {
                        path: '/alldiscussion',
                        element: <AllDiscussion />,
                    },
                    {
                        path: '/notifications',
                        element: <Notifications />,
                    },
                    {
                        path: '/settings',
                        element: <Settings />,
                    },
                    {
                        path: '/order-tags',
                        element: <OrderTags />,
                    },
                    {
                        path: '/track-order',
                        element: <TrackOrder />,
                    },
                    {
                        path: '/customers',
                        element: <Customers />,
                    },
                    {
                        path: '/customers/:id',
                        element: <CustomerDetail />,
                    },
                    {
                        path: '/customers/:id',
                        element: <CustomerDetail />,
                    },
                    { path: '/product_group', element: <ProductGroup /> },

                    {
                        path: '/product-view/:id', element: <Product />
                    },
                    {
                        path: '/catalog',
                        element: <Catalog />,
                    },
                    {
                        path: '/catalog-product/:type',
                        element: <CatalogProduct />,
                    },
                    {
                        path: '/help-center',
                        element: <HelpCenter />,
                    },
                    {
                        path: '/submitted-order/:id', element: <SubmittedProduct />
                    }
                        ]
                    }

                ],
                errorElement: <ErrorPage />
            },

        ]
    },
    {
        path: '/login',
        element: <Login />,
        errorElement: <ErrorPage />
    }
])